import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export function LiveTicker() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/live/ticker").then((r) => setItems(r.data.items || [])).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!items.length) return null;
  const loop = [...items, ...items];
  const anyLive = items.some((i) => i.state === "in");
  const dur = Math.max(4, items.length * 0.55);

  return (
    <div data-testid="live-ticker" className="relative z-40 flex items-stretch bg-[#0B0F18] border-y border-[#232D42] overflow-hidden">
      <div className="shrink-0 flex items-center gap-1.5 px-3 bg-[#00E5A3] text-[#04140F] font-mono text-[11px] font-bold uppercase tracking-wider">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#04140F] opacity-40" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#04140F]" />
        </span>
        {anyLive ? "Live" : "Games"}
      </div>
      <div className="flex-1 overflow-hidden">
        <div className="sq-marquee flex items-center gap-7 whitespace-nowrap py-2.5 pl-6" style={{ animationDuration: `${dur}s` }}>
          {loop.map((g, i) => {
            const live = g.state === "in";
            return (
              <Link key={`${g.id}-${i}`} to={`/games/${g.league}/${g.id}`}
                data-testid={`ticker-item-${i}`}
                className="inline-flex items-center gap-2 text-xs group">
                {live && (
                  <span className="relative flex h-1.5 w-1.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-60" />
                    <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500" />
                  </span>
                )}
                <span className="font-mono text-[10px] text-[#00E5A3]">{g.league}</span>
                <span className="text-slate-100 font-semibold group-hover:underline">
                  {g.away}{live && g.away_score != null ? ` ${g.away_score}` : ""}
                  <span className="text-slate-600 font-normal"> @ </span>
                  {g.home}{live && g.home_score != null ? ` ${g.home_score}` : ""}
                </span>
                <span className={live ? "text-red-400 font-mono text-[10px] uppercase" : "text-slate-500"}>
                  {g.detail}
                </span>
                <span className="text-slate-700 pl-4">•</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
